/* Start Calculator Slider Mobile */

const getHeightOfSlide = (currentChild) => {
  let calHeight = parseInt($(`#cal-slider .calc-slide:nth-child(${currentChild}) > div`).height());
  let paddingTop = parseInt($(`#cal-slider .calc-slide:nth-child(${currentChild})`).css('padding-top'));
  let paddingBottom = parseInt($(`#cal-slider .calc-slide:nth-child(${currentChild})`).css('padding-bottom'));
  return calHeight + paddingBottom + paddingTop;
}

function initializeSlider() {
  const carouselSlides = document.querySelectorAll('.calc-slide');
  const btnNext = document.querySelector('#calculate');
  const backNext = document.querySelector('#back-button');

  let currentChild = 1;
  let currentSlide = 0;

  $('#cal-slider').height(getHeightOfSlide(currentChild));

  const changeSlide = function (slides) {
    carouselSlides.forEach((slide, index) => {
      let pos = 100 * (index - slides);
      if (index > 0) {
        pos = pos - 100;
      }
      return slide.style.transform = `translateX(${pos}%)`
    });
  };
  changeSlide(currentSlide);

  btnNext.addEventListener('click', function () {
    currentSlide++;
    currentChild++;
    if (carouselSlides.length - 1 < currentSlide) {
      currentSlide = 0;
    };
    changeSlide(currentSlide);
    $('#cal-slider').height(getHeightOfSlide(currentChild));
    setTimeout(function () {
      changeSlide(currentSlide + 2);
      currentChild++;
      $('#cal-slider').height(getHeightOfSlide(currentChild));
    }, 1500)

  });

  backNext.addEventListener('click', function () {
    currentSlide;
    if (carouselSlides.length - 1 < currentSlide) {
      currentSlide = 0;
    };
    changeSlide(currentSlide);

    setTimeout(function () {
      changeSlide(--currentSlide);
      --currentChild;
      $('#cal-slider').height(getHeightOfSlide(currentChild));
    }, 800)
    --currentChild;
    $('#cal-slider').height(getHeightOfSlide(currentChild));
  });
};

$(document).ready(function(){
  if (window.innerWidth < 767) {
    initializeSlider();
  }
})

/* END Calculator Slider Mobile */

$('.investment-main .number-tags li').on('click', function () {
  const val = $(this).attr('value');
  const investmentInputElement = $('#investment')
  currentInvestmentValue = Number(removeCharsFromString(investmentInputElement.val()))
  investmentInputElement.val(getOuputFormat(parseInt(currentInvestmentValue) + parseInt(val))).trigger('input')
});

$('.decrement').click(function () {
  addInput('-', $(this).next())
});

$('.increment').click(function () {
  addInput('+', $(this).prev())
});

function removeCharsFromString(string) {
  return string.replace(/[^\d.]/g, '')
}

function addInput(operation, inputElement) {
  const currentValue = removeCharsFromString(inputElement.val())
  const newValue = Function("return " + `${currentValue} ${operation} 1`)()
  const outputType = inputElement.data('type')
  if (newValue > 0) {
    inputElement.val(getOuputFormat(newValue, outputType)).trigger('input')
  }
}

function setInput(currentInputElement){
  let value = currentInputElement.val()
  const cursorPosition = currentInputElement[0].selectionStart // Get the cursor position
  const outputType = currentInputElement.data('type')
  value = removeCharsFromString(value) // Remove any non-digit characters
  if (value !== '') {
    value = getOuputFormat(value, outputType)
  }
  currentInputElement.val(value);
  if (outputType == "percent" || outputType == "years") {
    currentInputElement[0].setSelectionRange(cursorPosition, cursorPosition);
  }

}

function getOuputFormat(value, type) {
  if (type == 'years') {
    return `${value}${value > 1 ? " years" : " year"}`
  }
  else if (type == "percent") {
    return `${value}%`
  }
  else if (type == "rupee") {
    return `₹ ${parseInt(Number(value))}`
  }
  else if (type == "none") {
    return parseInt(Number(value))
  }
  else {
    return `₹ ${parseInt(Number(value)).toLocaleString('en-IN')}`
  }
}

window.getOuputFormat = getOuputFormat